import React, {useState} from "react";

import {i18n} from 'translate/i18n'
import {getLogs} from "services/Logs.service";
import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';

import {useUser} from "store/providers/app";
import {useQuery} from "react-query";

import Page from "components/Page";
import {SelectUsers} from "components/Select";

import PaginationTable from "components/Pagination";
import {generatePdf} from "components/Exports/logs";
import {toast} from "react-toastify";
import {useNavigate} from "react-router";

const Logs = () => {

    const {user} = useUser()
    const navigate = useNavigate()

    const [logs, setLogs] = useState([]);
    const [selected, setSelected] = useState('');
    const [paginate, setPaginate] = useState([]);
    const [startDate, setStartDate] = useState(new Date().toISOString().substr(0, 10));
    const [endDate, setEndDate] = useState(new Date().toISOString().substr(0, 10));

    const [username, setUser] = useState(user.username);
    const [search, setSearch] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const {isFetching} = useQuery(["logs", username, currentPage, search],
        () => {
            return getLogs(username, currentPage, true, startDate, endDate)
        }, {
            onSuccess: (res) => {
                if (res) {
                    const {data} = res
                    setLogs(data.data)
                    setPaginate({
                        total: data.total,
                        from: data.from,
                        to: data.to
                    })
                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const onChangeUsers = (selected) => {
        setUser(selected.label)
    }

    const exportData = async () => {
        const res = await getLogs(selected, currentPage, false, startDate, endDate)
        generatePdf(res.data)
    }

    const searchLog = () => {
        setSearch([startDate, endDate])
        setSelected(user)
        setCurrentPage(1)
    }

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <Page label={i18n.t('titlePage.logs')} icon="bi bi-clock-history">

            <div className="card mt-3 border-0 shadow-sm">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <SelectUsers onChangeUsers={onChangeUsers}/>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group">
                                <input className="form-control" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                <input className="form-control" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-end">
                        <div className="col-12 pt-3">
                            <button className="btn btn-outline-success px-5 py-2 float-end" onClick={() => searchLog()}>
                                <i className="bi bi-search"/> {i18n.t('buttons.search')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mt-3 border-0 shadow-sm">
                <div className="card-header py-3">

                    <button
                        onClick={(e) => exportData(logs)}
                        className={`btn btn-outline-primary float-end ${!logs.length && "disabled"}`} type="button">
                        <i className="bi-filetype-pdf fs-5"/></button>

                </div>
                <div className="card-body table-responsive m-0 p-0">

                    <table className="table mb-0">
                        <thead className="bg-primary text-uppercase text-sm">
                        <tr>
                            <th className="py-4">{i18n.t('logs.headerTable')}</th>
                            <th className="py-4">{i18n.t('label.user')}</th>
                        </tr>
                        </thead>

                        <tbody>

                        {logs?.length === 0 &&
                            <tr>
                                <td colSpan={2}>{i18n.t('upload.tableRecords')}</td>
                            </tr>
                        }

                        {logs?.map(log =>
                            <tr key={log.id}>
                                <td className="text-sm">
                                    <p className="mb-0 text-muted bold-500">{log.title}</p>
                                    <p className="mb-0">{log.description}</p>
                                </td>

                                <td className="text-sm">
                                    <p className="mb-0 bold-500">{log.username}</p>
                                    <p className="mb-0 text-muted">{format(new Date(log.created_at), 'dd/MM/yyyy - HH:mm', {locale: ptBR})} </p>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="card-footer border-top-0 bg-white">
                    <PaginationTable
                        isFetching={isFetching}
                        paginate={paginate}
                        handlePageClick={handlePageClick}
                    />
                </div>
            </div>
        </Page>
    );
}

export default Logs
